import React from "react";
import { FormattedMessage } from "react-intl";

const RevaluationDrawerLogsDetails = ({filteredLogs}) => {
  return (
    <div
      style={{
        marginTop: "40px",
        display: "flex",
        flexDirection: "column" 
      }}>
      <span style={{marginLeft: "8px", fontSize: "16px", fontWeight: "bold", color: "#152935"}}>
        <FormattedMessage id="preCog.assetsTab.drawer.logs.revaluationDocInfoTitle" />
      </span>
      <span className="precog-assets-drawer-logs-sub-title">
        <FormattedMessage id="preCog.assetsTab.drawer.logs.docOpsInfoTitle" />
      </span>
      <div style={{display: "flex", flexWrap: "wrap"}}>
        <div>
          <span className="precog-assets-drawer-logs-purchase-info-title">
            <FormattedMessage id="preCog.assetsTab.drawer.logs.revaluationDate" />
          </span>
          <p className="precog-assets-drawer-logs-info">{filteredLogs[0]?.date === null ? "XXXXXXX" : moment(filteredLogs[0]?.date).format("DD/MM/YYYY")}</p>
        </div>
        <div>
          <span className="precog-assets-drawer-logs-purchase-info-title">
            <FormattedMessage id="preCog.assetsTab.drawer.logs.revaluationType" />
          </span>
          <p className="precog-assets-drawer-logs-info">{filteredLogs[0]?.revaluationType === null ? "XXXXXXX" : filteredLogs[0]?.revaluationType}</p>
        </div>
        {(filteredLogs[0]?.revaluationType === "STATUTORY" || filteredLogs[0]?.revaluationType === "TAX") && <div>
          <span className="precog-assets-drawer-logs-purchase-info-title">
            <FormattedMessage id="preCog.assetsTab.drawer.logs.revalutationScope" />
          </span>
          <p className="precog-assets-drawer-logs-info">{filteredLogs[0]?.revaluationType}</p>
        </div>}
        <div>
          <span className="precog-assets-drawer-logs-purchase-info-title">
            <FormattedMessage id="preCog.assetsTab.drawer.logs.currentValue" />
          </span>
          <p className="precog-assets-drawer-logs-info">{filteredLogs[0]?.amount === null ? "XXXXXXX" : `${numeral(filteredLogs[0]?.amount).format("0,0.00")} €`}</p>
        </div>
        <div>
          <span className="precog-assets-drawer-logs-purchase-info-title">
            <FormattedMessage id="preCog.assetsTab.drawer.logs.revaluationAmount" />
          </span>
          <p className="precog-assets-drawer-logs-info">{filteredLogs[0]?.logAmount === null ? "XXXXXXX" : `${numeral(filteredLogs[0]?.logAmount).format("0,0.00")} €`}</p>
        </div>
      </div>
    </div>
  );
};

export default RevaluationDrawerLogsDetails;